import React from "react";
import { connect } from "react-redux";
import Validator from "validator";
import isEmpty from "lodash/isEmpty";
import { PulseLoader } from "react-spinners";
import NotificationAlert from "react-notification-alert";
import { subscribeToMightyWifi } from "../modules/actions/authActions";
import { isEmailDomain } from "../modules/utils";

function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.email)) {
    errors.email = "Please Enter Email";
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}

class StayTouch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      errors: {},
      isLoading: false
    };
  }
  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  handleMailChimp = event => {
    event.preventDefault();
    if (this.isValid()) {
      const { email } = this.state;

      const emailPayload = {
        email
      };
      this.setState({ errors: {}, isLoading: true });
      this.props
        .subscribeToMightyWifi(emailPayload)
        .then(data => {
          console.log(data);
          if (data.status) {
            this.setState({ isLoading: false });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "success",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          } else {
            this.setState({ isLoading: false });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                <div>
                  <div>
                    <b>{data.message}</b>
                  </div>
                </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          }
        })
        .catch(error => {
          this.setState({ isLoading: false });
          this.refs.notify.notificationAlert({
            place: "tc",
            message: (
              <div>
                <div>
                  <b>{error.response.data.message}</b>
                </div>
              </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
          });
        });
    }
  };

  render() {
    const { errors, email } = this.state;
    return (
      <section className="section bg-video text-white offer-section">
        <div className="container">
          <div className="row mt-1">
            <NotificationAlert ref="notify" />
            <div className="col-lg-12">
              <PulseLoader
                className="sweet-loading"
                sizeUnit={"px"}
                size={20}
                color={"#123abc"}
                loading={this.state.isLoading}
              />
              <div className="video_desc mx-auto text-center">
                <h2 className="Title bold600">
                  Stay in touch & <span className="m-break">Get special offers</span>
                </h2>
                <p className="mb-5">By entering your email address, you agree to receive our email, <span className="d-break">promotions and other commercial messages.</span></p>

                <form onSubmit={this.handleMailChimp}>
                    <div className="row justify-content-md-center">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          name="email"
                          ref={this.email}
                          onChange={this._onChange}
                          className="form-control"
                          placeholder="Enter your email"
                          className="form-control-news"
                        />
                        {errors.email && (
                          <span className="error-color">{errors.email}</span>
                        )}
                        <input
                          type="submit"
                          className="btn btn-newsletter"
                          value="JOIN"
                        />
                      </div>
                      </div>
                    </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}
export default connect(
  mapStateToProps,
  {
    subscribeToMightyWifi
  }
)(StayTouch);



// WEBPACK FOOTER //
// ./src/layout/StayTouch.js